import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { usePermissionCache } from './cache'
import {
  type PermissionUpdateInput,
  type PermissionUpdateSuccess,
  type PermissionType,
  toResponseError,
} from '@terros/common'

export function useUpdatePermission(): UpdateHookResponse<
  PermissionUpdateInput<PermissionType>,
  PermissionUpdateSuccess
> {
  const cache = usePermissionCache()

  const mutation = useTantalimMutation<PermissionUpdateInput<PermissionType>, PermissionUpdateSuccess>({
    url: '/permission/update',
  })

  async function update(input: PermissionUpdateInput<PermissionType>): Promise<PermissionUpdateSuccess> {
    try {
      const response = await mutation.mutateAsync(input)

      cache.clearEntityPermission(input.entityId)

      return response
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
